import { anotherComponentHookCriteria } from '../../helpers';
export function editorNavigationPlugin(flowApi) {
  return function (router) {
    router.transitionService.onBefore({
      to: anotherComponentHookCriteria
    }, handleNavigation);
    try {
      const params = JSON.parse(flowApi.controllerConfig.wixCodeApi.location.query.appSectionParams);
      if (params.state) {
        router.urlService.rules.initial(params);
      }
    } catch {}
    return {
      name: 'WixUIRouterEditorNavigation'
    };
  };
  async function handleNavigation(transition) {
    const {
      controllerConfig
    } = flowApi;
    const {
      wixCodeApi,
      compId
    } = controllerConfig;
    const to = transition.to();
    const section = {
      compId,
      noTransition: true,
      sectionId: to.data.sectionId,
      queryParams: {
        state: to.name,
        params: transition.params('to')
      }
    };
    wixCodeApi.location.navigateToSection(section);
  }
}
//# sourceMappingURL=plugin.js.map